import React from 'react';
import SavedItemsManagement from '../components/SavedItemsManagement';

function SavedItems() {
  return <SavedItemsManagement />;
}

export default SavedItems;